export default __webpack_public_path__ + "static/media/goal3d.741fb35c.png";